import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import { sessionReducer } from 'redux-react-session'
import mediaQuery from './mediaQuery'
import modal from './modal'
import pages from './pages'
import signup from './signup'
import login from './login'
import info from './info'
import promotionalPlayer from './promotionalPlayer'
import previewPlayer from './previewPlayer'
import newCourse from './newCourse'
import addNewCourse from './addNewCourse'
import player from './player'
import review from './review'
import contact from './contact'
import verify from './verify'
import instructor from './instructor'
import step from './step'
import categories from './categories'
import province from './province'
import amphures from './amphures'
import contactStuff from './contactStuff'
import example from './example'
import live from './live'
import schedule from './schedule'
import tutorRegister from '../components/tutorRegister/reducers'


import lineInfo from '../components/LineStudentRegister/reducer'
import lineFormDetail from '../components/LineFormDetail/reducer'
import payment from '../components/Payment/reducer'

const reducers = combineReducers({
  router: routerReducer,
  session: sessionReducer,
  mediaQuery,
  modal,
  pages,
  signup,
  login,
  info,
  promotionalPlayer,
  previewPlayer,
  newCourse,
  player,
  review,
  contact,
  verify,
  instructor,
  step,
  categories,
  province,
  amphures,
  contactStuff,
  example,
  addNewCourse,
  live,
  schedule,
  tutorRegister,
  lineInfo,
  lineFormDetail,
  payment,
})

export default reducers



// WEBPACK FOOTER //
// ./src/reducers/index.js